var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.urlPath == 'blog')?_c('div',{staticClass:"web-body"},[_c('blog')],1):(_vm.urlPath == 'policy')?_c('div',{staticClass:"web-body"},[_c('policy')],1):_c('div',{staticClass:"web-body"},[(_vm.urlPath == '')?_c('div',[_c('slide')],1):_vm._e(),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.body)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24db9c97","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Body.vue
// module id = 163
// module chunks = 0